export default __webpack_public_path__ + "static/media/APxM_logo_Stacked-02.b782c0b6.png";